const isUrl = (ufo) => {
    return ufo ? ufo.match(/^https?:/) : false
}

export {
    isUrl
}



// WEBPACK FOOTER //
// ./src/helpers/chisels.js